<template>
    <span>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="value > 0">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 8C0.5 3.85775 3.85775 0.5 8 0.5C12.1423 0.5 15.5 3.85775 15.5 8C15.5 12.1423 12.1423 15.5 8 15.5C3.85775 15.5 0.5 12.1423 0.5 8ZM8 4.25C7.586 4.25 7.25 4.586 7.25 5V8.75C7.25 9.164 7.586 9.5 8 9.5C8.414 9.5 8.75 9.164 8.75 8.75V5C8.75 4.586 8.414 4.25 8 4.25ZM8 10.25C7.586 10.25 7.25 10.586 7.25 11C7.25 11.414 7.586 11.75 8 11.75C8.414 11.75 8.75 11.414 8.75 11C8.75 10.586 8.414 10.25 8 10.25Z" :fill="color"/>
        </svg>
    </span>
</template>

<script>
import Column from '@mixins/Column';

export default {
    mixins: [ Column ],
    computed: {
        color() {
            return ( this.value == 2 ) ? '#C11F40' : '#7F91A7';
        }
    }
}
</script>
